module.exports = __webpack_public_path__ + "img/refresh.4d7a42c8.svg";